import {
	AGENDA_EVENT_GET,
	ATTENDEE_EVENT_GET,
	ATTENDEES_EVENT_GET,
	ATTENDEES_EVENT_CLEAR,
	EVENT_GET,
	EVENT_GET_ERROR,
	EVENT_LOADING_STATUS,
	EVENTS_FETCH,
	EVENTS_FETCH_CATEGORIES,
	GET_ACTION_LINKS,
	PARTNERS_EVENT_GET,
	REMOVE_ATTENDEES_EVENT,
	SESSION_EVENT_GET,
	SESSION_EVENT_CLEAR,
	GET_ACTION_FILES,
	SESSION_EVENT_QUESTIONS_GET,
	SESSION_EVENT_QUESTION_UPDATE,
	SESSION_EVENT_QUESTIONS_CLEAR,
	EVENTS_CLEAR,
	EVENT_LOADING_CATEGORIES_STATUS,
	EVENT_GET_TRACKS,
	EVENT_TRACKS_LOADING_STATUS,
	EVENT_CLEAR_TRACKS,
	EVENT_MY_AGENDA_LOADING_STATUS,
	EVENT_AGENDA_UPDATE_ITEM,
	EVENT_POLLS_LOADING_STATUS,
	UPDATE_EVENT_POLLS,
	EVENT_SPEAKERS_GET,
	EVENT_SPEAKERS_CLEAR,
	EVENT_RATINGS_LOADING_STATUS,
	UPDATE_EVENT_RATINGS,
	UPDATE_SESSION_RATINGS,
	EVENT_GET_EXHIBITOR,
	SET_FOLLOW_STATUS,
	SET_FOLLOW_NOTE,
	GET_BOOT_STAFF_LIST,
	BOOT_STAFF_LOADING_STATUS,
	EVENTS_FETCH_ERROR,
	DELETE_FOLLOW_NOTE,
} from '@/store/event/types'
import { removeAgendaItem, updateAgendaItem } from '../../utils/helpers'

const initialState = {
	loading: false,
	loadingCategories: false,
	event: {},
	agenda: [],
	errors: [],
	events: [],
	session: null,
	sessionQuestions: null,
	partners: [],
	attendees: [],
	attendee: null,
	categories: [],
	categoriesMeta: null,
	actionFiles: [],
	actionLinks: [],
	speakers: [],
	speakersMeta: null,
	exhibitor: null,

	tracks: [],
	tracksMeta: null,
	loadingTracks: false,

	actionLinksMeta: null,
	actionFilesMeta: null,
	sessionQuestionsMeta: null,

	pageCount: {
		events: 0,
		agendas: 0,
		partners: 0,
		attendees: 0,
		boothStaff: 0,
	},
	totalCount: {
		attendees: 0,
		boothStaff: 0,
	},
	myAgendaIsLoading: false,
	myAgendaIdIsLoading: null,
	pollsLoading: false,
	ratingsLoading: false,
	exhibitorPartner: {
		follow_status: null,
		follow_note: '',
	},
	boothStaffList: [],
	boothStaffLoading: false,
}

export const state = { ...initialState }

export default {
	[GET_BOOT_STAFF_LIST]: (state, payload) => {
		state.boothStaffList = [...payload.data]
		state.pageCount.boothStaff = +payload.pageCount
		state.totalCount.boothStaff = +payload.totalCount
	},
	[BOOT_STAFF_LOADING_STATUS]: (state, status) => {
		state.boothStaffLoading = status
	},

	[EVENT_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[EVENTS_FETCH]: (state, payload) => {
		state.event = initialState.post
		state.events = [...payload.data]
		state.pageCount.events = +payload.pageCount
	},

	[EVENTS_FETCH_CATEGORIES]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.categories = [...state.categories, ...data]
		state.categoriesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[GET_ACTION_LINKS]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload

		state.actionLinks = data
		state.actionLinksMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[GET_ACTION_FILES]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload

		state.actionFiles = data
		state.actionFilesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[EVENT_GET]: (state, payload) => {
		state.event = payload
		state.agenda = initialState.agenda
	},

	[REMOVE_ATTENDEES_EVENT]: (state) => {
		state.attendees = []
	},

	[AGENDA_EVENT_GET]: (state, payload) => {
		state.agenda = [...payload.data]
		state.pageCount.agendas = +payload.pageCount
	},

	[SESSION_EVENT_GET]: (state, payload) => {
		state.session = payload
	},

	[SESSION_EVENT_CLEAR]: (state) => {
		state.session = null
	},

	[ATTENDEES_EVENT_GET]: (state, payload) => {
		state.attendees = [...payload.data]
		state.pageCount.attendees = +payload.pageCount
		state.totalCount.attendees = +payload.totalCount
	},

	[ATTENDEES_EVENT_CLEAR]: (state) => {
		state.attendees = []
	},

	[ATTENDEE_EVENT_GET]: (state, payload) => {
		state.attendee = payload
	},

	[PARTNERS_EVENT_GET]: (state, payload) => {
		state.partners = [...payload.data]
		state.pageCount.partners = +payload.pageCount
	},

	[EVENT_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[SESSION_EVENT_QUESTIONS_GET]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.sessionQuestions = data
		state.sessionQuestionsMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[SESSION_EVENT_QUESTIONS_CLEAR]: (state) => {
		state.sessionQuestions = null
		state.sessionQuestionsMeta = null
	},

	[SESSION_EVENT_QUESTION_UPDATE]: (state, payload) => {
		state.sessionQuestions = state.sessionQuestions.map((question) => {
			if (question.session_question_answer_id === payload.answerId) {
				return {
					...question,
					upvote: payload.status,
					session_question_count: payload.status
						? question.session_question_count + 1
						: question.session_question_count - 1,
				}
			} else {
				return question
			}
		})
	},

	[EVENTS_CLEAR]: (state) => {
		state.categories = []
		state.categoriesMeta = null
	},

	[EVENT_LOADING_CATEGORIES_STATUS]: (state, payload) => {
		state.loadingCategories = payload
	},

	[EVENT_GET_TRACKS]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.tracks = [...state.tracks, ...data]
		state.tracksMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[EVENT_CLEAR_TRACKS]: (state) => {
		state.tracks = []
		state.tracksMeta = null
	},

	[EVENT_TRACKS_LOADING_STATUS]: (state, value) => {
		state.loadingTracks = value
	},

	[EVENT_MY_AGENDA_LOADING_STATUS]: (state, payload) => {
		state.myAgendaIsLoading = payload.value
		state.myAgendaIdIsLoading = payload.id || null
	},

	[EVENT_AGENDA_UPDATE_ITEM]: (state, { agenda, id, remove, filter }) => {
		if (remove) {
			if (filter === 'scheduled') {
				state.agenda = removeAgendaItem(state, id)
			} else {
				state.agenda = agenda.is_registered
					? updateAgendaItem(state, id, agenda)
					: removeAgendaItem(state, id)
			}
		} else {
			state.agenda = updateAgendaItem(state, id, agenda)
		}
	},

	[EVENT_POLLS_LOADING_STATUS]: (state, status) => {
		state.pollsLoading = status
	},

	[UPDATE_EVENT_POLLS]: (state, polls) => {
		state.event = { ...state.event, polls }
	},

	[EVENT_SPEAKERS_GET]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.speakers = data
		state.speakersMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[EVENT_SPEAKERS_CLEAR]: (state) => {
		;(state.speakers = []), (state.speakersMeta = null)
	},

	[EVENT_RATINGS_LOADING_STATUS]: (state, status) => {
		state.ratingsLoading = status
	},

	[UPDATE_EVENT_RATINGS]: (state, ratings) => {
		state.event = { ...state.event, ratings }
	},

	[UPDATE_SESSION_RATINGS]: (state, ratings) => {
		state.session = { ...state.session, ratings }
	},

	[EVENT_GET_EXHIBITOR]: (state, exhibitor) => {
		state.exhibitor = exhibitor
	},
	[SET_FOLLOW_STATUS]: (state, status) => {
		state.exhibitorPartner.follow_status = status
	},
	[SET_FOLLOW_NOTE]: (state, note) => {
		state.exhibitorPartner.follow_note = note
	},
	[DELETE_FOLLOW_NOTE]: (state, note) => {
		state.exhibitorPartner.follow_note = note
	},
	[EVENTS_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
}
